export default __webpack_public_path__ + "static/media/inventory.5bb8a763.png";